import type { WorkItem } from "@/types";

export const workTypes = ["全部", "TV动画", "剧场版电影", "漫画", "OVA", "网络动画"];
export const workRegions = ["全部", "日本", "中国", "欧美", "韩国"];
export const workYears = ["全部", "2026", "2025", "2024", "2023", "更早"];

export const worksList: WorkItem[] = [
  {
    id: "w1",
    title: "星海回声",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20poster%20illustration%20of%20a%20young%20space%20explorer%20in%20a%20sleek%20flight%20suit%20standing%20before%20a%20glowing%20nebula%2C%20flat%20cel%20shading%2C%20vibrant%20green%20and%20teal%20palette%2C%20clean%20gradient%20background%2C%20official%20poster%20style&width=600&height=800&seq=work-01&orientation=portrait",
    type: "TV动画",
    region: "日本",
    year: 2026,
    heat: 9860,
    tags: ["科幻", "冒险", "群像"],
    author: "原作：星野遥",
    studio: "清晨动画工房",
    synopsis: "一支年轻的探索船队驶向未知星域，在冒险中寻找家园与自我的故事。",
    description:
      "《星海回声》以一支年轻的探索船队为主角，讲述他们在未知星域中航行、相遇与成长的故事。作品将宏大的宇宙设定与细腻的人物关系结合，既有紧张刺激的冒险段落，也有温暖动人的人情描写。第二季将深入更遥远的星域，揭开第一季留下的悬念。",
    characters: [
      { name: "凛", role: "主角 / 领航员", desc: "沉着冷静的年轻领航员，背负着寻找故乡的执念。" },
      { name: "阿彻", role: "工程师", desc: "乐观随性的机械师，团队里的气氛担当。" },
      { name: "米娅", role: "通讯员", desc: "细心温柔的通讯员，负责维系团队的情绪。" },
    ],
  },
  {
    id: "w2",
    title: "青空料理帖",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20anime%20poster%20illustration%20of%20a%20smiling%20young%20chef%20holding%20a%20steaming%20bowl%20in%20a%20sunlit%20kitchen%2C%20flat%20cel%20shading%2C%20soft%20cream%20and%20green%20palette%2C%20clean%20cozy%20background%2C%20wholesome%20poster%20style&width=600&height=800&seq=work-02&orientation=portrait",
    type: "漫画",
    region: "日本",
    year: 2024,
    heat: 8740,
    tags: ["治愈", "美食", "日常"],
    author: "原作：南野葵",
    studio: "青空书房",
    synopsis: "一间小餐馆与它的常客们的故事，用一道道家常料理串起平凡而温暖的日常。",
    description:
      "《青空料理帖》围绕一间开在街角的小餐馆展开，用一道道家常料理串起店主与常客之间的温暖日常。作品节奏舒缓，注重对食物与人情的细腻描写，读起来令人安心。系列累计发行量突破两千万册，是近年料理题材的代表作。",
    characters: [
      { name: "夏川澄", role: "主角 / 店主", desc: "安静内敛的年轻店主，擅长用料理抚慰人心。" },
      { name: "爷爷", role: "常客", desc: "每日准点出现的老客人，习惯点同一碗面。" },
    ],
  },
  {
    id: "w3",
    title: "雾都侦探社",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20anime%20poster%20illustration%20of%20a%20sharp%20eyed%20detective%20in%20a%20trench%20coat%20under%20gaslamps%20in%20fog%2C%20dramatic%20flat%20cel%20shading%2C%20deep%20teal%20and%20amber%20palette%2C%20clean%20atmospheric%20background%2C%20mystery%20poster%20style&width=600&height=800&seq=work-03&orientation=portrait",
    type: "TV动画",
    region: "日本",
    year: 2026,
    heat: 9120,
    tags: ["悬疑", "推理", "剧情"],
    author: "原作：黑泽牧",
    studio: "雾灯映像",
    synopsis: "在终日被雾气笼罩的城市里，一名侦探与他的搭档追寻着一连串看似无关的案件。",
    description:
      "《雾都侦探社》以一座常年被雾气笼罩的城市为舞台，讲述侦探与搭档追寻一连串看似无关的案件。作品剧本扎实，线索布置克制而有迹可循，同时用环境与光影营造出浓厚的悬疑氛围。主角的犹豫与成长贯穿始终，是本季口碑黑马。",
    characters: [
      { name: "伊恩", role: "主角 / 侦探", desc: "观察力敏锐的侦探，习惯用沉默掩饰情绪。" },
      { name: "诺拉", role: "搭档", desc: "行动力强的搭档，常打破伊恩的固有思路。" },
    ],
  },
  {
    id: "w4",
    title: "银月骑士团",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20anime%20poster%20illustration%20of%20armored%20knights%20raising%20swords%20under%20a%20giant%20silver%20moon%2C%20flat%20cel%20shading%2C%20silver%20blue%20and%20gold%20palette%2C%20dramatic%20clean%20background%2C%20fantasy%20poster%20style&width=600&height=800&seq=work-04&orientation=portrait",
    type: "剧场版电影",
    region: "日本",
    year: 2026,
    heat: 8210,
    tags: ["奇幻", "热血", "战斗"],
    author: "原作：白银社",
    studio: "月光制作组",
    synopsis: "一支被放逐的骑士团，在月夜之下誓要夺回属于他们的荣耀。",
    description:
      "《银月骑士团》讲述一支被放逐的骑士团，在月夜之下立誓夺回荣耀的奇幻故事。作品以宏大的战斗场面与鲜明的角色群像著称，剧场版将采用全新的故事线，加入更多舞台化的演出设计，动作场面较 TV 版有明显升级。",
    characters: [
      { name: "盖尔", role: "团长", desc: "背负放逐之名仍不放弃信念的骑士团长。" },
      { name: "莉娅", role: "剑士", desc: "剑术出众、性格直率的女骑士。" },
    ],
  },
  {
    id: "w5",
    title: "四月信笺",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20healing%20anime%20poster%20illustration%20of%20a%20girl%20holding%20a%20letter%20as%20cherry%20petals%20drift%20around%20her%2C%20gentle%20flat%20cel%20shading%2C%20pastel%20pink%20and%20sage%20green%20palette%2C%20clean%20airy%20background%2C%20tender%20poster%20style&width=600&height=800&seq=work-05&orientation=portrait",
    type: "TV动画",
    region: "日本",
    year: 2026,
    heat: 7890,
    tags: ["治愈", "剧情", "青春"],
    author: "原创企划",
    studio: "纸鸢动画",
    synopsis: "以书信为线索，串联起两代人跨越时空的情感故事。",
    description:
      "《四月信笺》是一部原创动画，以书信为线索串联起两代人跨越时空的情感。作品更愿意把镜头留给日常细节：窗边的风、未寄出的信、缓慢展开的回忆，叙事克制而真挚，适合安静观看、慢慢体会。",
    characters: [
      { name: "诗织", role: "主角", desc: "喜欢写信的高中生，执着于寻找信封的收件人。" },
      { name: "外婆", role: "回忆支线", desc: "信件真正的主人，承载着一段旧时光。" },
    ],
  },
  {
    id: "w6",
    title: "夜航少年",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20anime%20poster%20illustration%20of%20a%20lone%20boy%20on%20a%20boat%20sailing%20under%20glowing%20constellations%2C%20flat%20cel%20shading%2C%20deep%20navy%20and%20teal%20palette%2C%20clean%20dreamy%20background%2C%20adventure%20poster%20style&width=600&height=800&seq=work-06&orientation=portrait",
    type: "漫画",
    region: "日本",
    year: 2023,
    heat: 7560,
    tags: ["冒险", "悬疑", "成长"],
    author: "原作：海野渡",
    studio: "夜航社",
    synopsis: "一名少年在星夜航行中追寻真相的旅程，融合冒险、悬疑与成长。",
    description:
      "《夜航少年》讲述一名少年在星夜航行中追寻真相的旅程。原作以「夜航」为核心意象，将冒险、悬疑与成长元素巧妙融合，拥有稳定的读者群。动画化作品将于冬季档期首播。",
    characters: [
      { name: "凛太郎", role: "主角", desc: "独自驾船远行的少年，心中藏着未解的谜题。" },
      { name: "灯塔老人", role: "引路人", desc: "守在岸边灯塔的神秘老人，知晓许多往事。" },
    ],
  },
  {
    id: "w7",
    title: "春日野营",
    cover:
      "https://readdy.ai/api/search-image?query=Peaceful%20anime%20poster%20illustration%20of%20friends%20around%20a%20campfire%20and%20tent%20by%20a%20lake%20at%20sunset%2C%20flat%20cel%20shading%2C%20warm%20green%20and%20golden%20palette%2C%20clean%20nature%20background%2C%20cozy%20poster%20style&width=600&height=800&seq=work-07&orientation=portrait",
    type: "TV动画",
    region: "日本",
    year: 2025,
    heat: 6980,
    tags: ["治愈", "日常", "户外"],
    author: "原作：山吹社",
    studio: "野营制作组",
    synopsis: "一群好友结伴露营的温暖日常，记录四季里的户外时光。",
    description:
      "《春日野营》讲述一群好友结伴露营的温暖日常。作品凭借舒缓的节奏与细腻的自然描写积累了良好口碑，观众普遍表示能从中获得「深呼吸」般的放松感。第三季将解锁更多新的露营地点与季节风景。",
    characters: [
      { name: "千夏", role: "主角", desc: "热爱户外、总是充满活力的露营发起人。" },
      { name: "小满", role: "好友", desc: "负责美食的同伴，擅长用简单食材做出好味道。" },
    ],
  },
  {
    id: "w8",
    title: "玻璃花与纸飞机",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20anime%20poster%20illustration%20of%20teenagers%20on%20a%20school%20rooftop%20flying%20paper%20planes%20under%20a%20clear%20sky%2C%20flat%20cel%20shading%2C%20soft%20blue%20and%20green%20palette%2C%20clean%20nostalgic%20background%2C%20youth%20poster%20style&width=600&height=800&seq=work-08&orientation=portrait",
    type: "OVA",
    region: "日本",
    year: 2024,
    heat: 6420,
    tags: ["青春", "校园", "剧情"],
    author: "原作：星屑社",
    studio: "纸飞机动画",
    synopsis: "青春群像作品，讲述一群高中生在毕业前最后一个夏天的故事。",
    description:
      "《玻璃花与纸飞机》是一部青春群像作品，讲述一群高中生在毕业前最后一个夏天发生的故事。作品氛围怀旧而清澈，充满年代感的场景与细腻的情感描写相得益彰。OVA 特别篇为本篇之外的配角补上关键的一笔。",
    characters: [
      { name: "悠真", role: "主角", desc: "安静细腻的少年，总在天台折纸飞机。" },
      { name: "纱罗", role: "好友", desc: "开朗直率，是朋友圈里最主动的那一个。" },
    ],
  },
  {
    id: "w9",
    title: "墨色江湖",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20ink%20style%20anime%20poster%20illustration%20of%20a%20swordsman%20looking%20over%20misty%20mountains%20with%20flowing%20ink%20strokes%2C%20flat%20cel%20shading%2C%20monochrome%20ink%20with%20a%20touch%20of%20green%2C%20clean%20elegant%20background%2C%20wuxia%20poster%20style&width=600&height=800&seq=work-09&orientation=portrait",
    type: "网络动画",
    region: "中国",
    year: 2025,
    heat: 8340,
    tags: ["武侠", "水墨", "剧情"],
    author: "原作：墨白",
    studio: "山水动画",
    synopsis: "水墨画风下的武侠故事，一名剑客游走江湖，追寻道义与初心。",
    description:
      "《墨色江湖》以水墨画风呈现一段武侠故事，讲述一名剑客游走江湖、追寻道义与初心的历程。作品在视觉上大胆采用写意笔触，动作设计行云流水，是近年国风动画中颇具辨识度的一部。",
    characters: [
      { name: "沈墨", role: "主角", desc: "独来独往的剑客，寡言却重情义。" },
      { name: "阿禾", role: "同伴", desc: "机灵的江湖小贩，常为沈墨带来线索。" },
    ],
  },
  {
    id: "w10",
    title: "像素纪元",
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20pixel%20art%20anime%20poster%20illustration%20of%20a%20hero%20character%20with%20a%20glowing%20sword%20in%20a%20neon%20city%2C%20vibrant%20green%20and%20orange%20palette%2C%20clean%20stylized%20background%2C%20gaming%20poster%20style&width=600&height=800&seq=work-10&orientation=portrait",
    type: "网络动画",
    region: "欧美",
    year: 2026,
    heat: 7120,
    tags: ["科幻", "游戏", "热血"],
    author: "原创企划",
    studio: "像素工坊",
    synopsis: "当游戏世界与现实重叠，一群玩家必须站出来守护两个世界。",
    description:
      "《像素纪元》讲述当游戏世界与现实重叠后，一群玩家被迫站出来守护两个世界的故事。作品视觉上融合像素美学与现代动画演出，节奏明快，战斗设计富有创意，深受年轻观众喜爱。",
    characters: [
      { name: "凯", role: "主角", desc: "反应极快的资深玩家，习惯用策略化解危机。" },
      { name: "妮可", role: "搭档", desc: "擅长解谜的搭档，负责破解系统谜题。" },
    ],
  },
  {
    id: "w11",
    title: "花火公寓",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20anime%20poster%20illustration%20of%20friendly%20neighbors%20gathered%20in%20an%20apartment%20courtyard%20watching%20fireworks%2C%20flat%20cel%20shading%2C%20warm%20orange%20and%20green%20palette%2C%20clean%20evening%20background%2C%20slice%20of%20life%20poster%20style&width=600&height=800&seq=work-11&orientation=portrait",
    type: "漫画",
    region: "韩国",
    year: 2025,
    heat: 6540,
    tags: ["日常", "治愈", "群像"],
    author: "原作：尹夏琳",
    studio: "花火工作室",
    synopsis: "一栋老式公寓里，形形色色的住户上演着各自的温暖故事。",
    description:
      "《花火公寓》以一栋老式公寓为舞台，描绘形形色色住户之间发生的温暖故事。作品用轻松幽默的笔触刻画群像，每一话都围绕一个角色展开，读来亲切又治愈。",
    characters: [
      { name: "房东阿姨", role: "贯穿角色", desc: "热心肠的房东，是整栋楼的情感枢纽。" },
      { name: "小俊", role: "住户", desc: "刚搬来的年轻租客，渐渐融入公寓的日常。" },
    ],
  },
  {
    id: "w12",
    title: "钢铁航线",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20poster%20illustration%20of%20a%20giant%20mecha%20robot%20standing%20on%20an%20aircraft%20carrier%20deck%20at%20dawn%2C%20flat%20cel%20shading%2C%20steel%20grey%20and%20green%20palette%2C%20clean%20industrial%20background%2C%20mecha%20poster%20style&width=600&height=800&seq=work-12&orientation=portrait",
    type: "TV动画",
    region: "日本",
    year: 2024,
    heat: 8060,
    tags: ["机甲", "科幻", "战斗"],
    author: "原作：钢铁社",
    studio: "航线动画",
    synopsis: "一支年轻的机甲小队，在辽阔的钢铁航线上迎战未知威胁。",
    description:
      "《钢铁航线》讲述一支年轻的机甲小队在辽阔航线上迎战未知威胁的故事。作品在机甲设计与战斗演出上投入了大量精力，动作流畅、分镜清晰，同时也没有忽略队员之间的羁绊描写。",
    characters: [
      { name: "拓真", role: "主角 / 驾驶员", desc: "天赋出众却爱逞强的年轻驾驶员。" },
      { name: "岚", role: "队长", desc: "经验丰富、沉稳可靠的队长。" },
    ],
  },
  {
    id: "w13",
    title: "甜点物语",
    cover:
      "https://readdy.ai/api/search-image?query=Cheerful%20anime%20poster%20illustration%20of%20a%20patissier%20surrounded%20by%20colorful%20cakes%20and%20desserts%20in%20a%20bright%20bakery%2C%20flat%20cel%20shading%2C%20sweet%20pink%20and%20green%20palette%2C%20clean%20cheerful%20background%2C%20dessert%20poster%20style&width=600&height=800&seq=work-13&orientation=portrait",
    type: "TV动画",
    region: "日本",
    year: 2023,
    heat: 5880,
    tags: ["美食", "治愈", "日常"],
    author: "原作：甜点社",
    studio: "糖霜动画",
    synopsis: "为了传承一间老字号甜品店，少女决心成为最出色的甜点师。",
    description:
      "《甜点物语》讲述一名少女为了传承家中的老字号甜品店，决心成为出色甜点师的故事。作品色彩明快、氛围轻松，将甜点制作的过程描绘得诱人又细致，是一部充满幸福感的作品。",
    characters: [
      { name: "千层", role: "主角", desc: "目标坚定的学徒，对味道有着惊人的直觉。" },
      { name: "师傅", role: "引路人", desc: "严厉却心软的甜点师傅。" },
    ],
  },
  {
    id: "w14",
    title: "远山邮差",
    cover:
      "https://readdy.ai/api/search-image?query=Gentle%20anime%20poster%20illustration%20of%20a%20postman%20cycling%20along%20a%20mountain%20road%20in%20autumn%2C%20flat%20cel%20shading%2C%20warm%20amber%20and%20green%20palette%2C%20clean%20nature%20background%2C%20healing%20poster%20style&width=600&height=800&seq=work-14&orientation=portrait",
    type: "剧场版电影",
    region: "中国",
    year: 2025,
    heat: 6720,
    tags: ["剧情", "治愈", "人文"],
    author: "原创企划",
    studio: "远山动画",
    synopsis: "一位山村邮差几十年如一日送信的故事，见证山乡的变迁与人情。",
    description:
      "《远山邮差》讲述一位山村邮差几十年如一日坚持送信的故事。作品以朴素克制的叙事，见证山乡的变迁与人情的温度，画面温暖沉静，是一部适合静下心来细细品味的剧场版动画。",
    characters: [
      { name: "老周", role: "主角 / 邮差", desc: "走了半辈子山路的邮差，认得每一户人家。" },
      { name: "小敏", role: "陪伴者", desc: "在邮局帮忙的年轻人，为老周带来新的视角。" },
    ],
  },
  {
    id: "w15",
    title: "深海回音",
    cover:
      "https://readdy.ai/api/search-image?query=Mysterious%20anime%20poster%20illustration%20of%20a%20diver%20descending%20into%20a%20glowing%20deep%20sea%20trench%20with%20bioluminescent%20creatures%2C%20flat%20cel%20shading%2C%20deep%20teal%20and%20green%20palette%2C%20clean%20atmospheric%20background%2C%20sci-fi%20poster%20style&width=600&height=800&seq=work-15&orientation=portrait",
    type: "TV动画",
    region: "日本",
    year: 2026,
    heat: 7480,
    tags: ["科幻", "悬疑", "冒险"],
    author: "原作：海渊遥",
    studio: "回音制作组",
    synopsis: "深海中传来的神秘回音，将一支科考队引向未知的海底世界。",
    description:
      "《深海回音》讲述深海中传来的神秘回音，将一支科考队引向未知海底世界的故事。作品以幽深的海底场景与紧张的悬疑氛围见长，配乐与音效表现尤为出色，营造出强烈的沉浸感。",
    characters: [
      { name: "琉", role: "主角 / 潜航员", desc: "直觉敏锐的潜航员，对深海有着特殊的向往。" },
      { name: "博士", role: "领队", desc: "执着于研究海底回音的科学家。" },
    ],
  },
  {
    id: "w16",
    title: "纸鸢与风",
    cover:
      "https://readdy.ai/api/search-image?query=Airy%20anime%20poster%20illustration%20of%20a%20girl%20flying%20a%20kite%20on%20a%20grassy%20hill%20with%20wind%20and%20dandelions%2C%20flat%20cel%20shading%2C%20fresh%20green%20and%20sky%20blue%20palette%2C%20clean%20open%20background%2C%20youth%20poster%20style&width=600&height=800&seq=work-16&orientation=portrait",
    type: "网络动画",
    region: "中国",
    year: 2024,
    heat: 6040,
    tags: ["青春", "成长", "日常"],
    author: "原作：风间社",
    studio: "纸鸢动画",
    synopsis: "一个关于梦想与放手的故事，像纸鸢一样迎风而上。",
    description:
      "《纸鸢与风》讲述一个关于梦想与放手的故事。作品以放风筝为隐喻，描绘少年在成长中学会面对离别与选择的过程。画风清新明亮，情感真挚，适合全家一起观看。",
    characters: [
      { name: "小鸢", role: "主角", desc: "喜欢放风筝的女孩，执着于让风筝飞得更高。" },
      { name: "爷爷", role: "陪伴者", desc: "教会小鸢放风筝的爷爷，教会她如何面对放手。" },
    ],
  },
  {
    id: "w17",
    title: "月下咖啡馆",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20anime%20poster%20illustration%20of%20a%20late%20night%20cafe%20with%20warm%20glowing%20windows%20and%20a%20barista%20under%20the%20moon%2C%20flat%20cel%20shading%2C%20warm%20amber%20and%20deep%20green%20palette%2C%20clean%20night%20background%2C%20healing%20poster%20style&width=600&height=800&seq=work-17&orientation=portrait",
    type: "漫画",
    region: "韩国",
    year: 2026,
    heat: 5660,
    tags: ["治愈", "都市", "情感"],
    author: "原作：夜茶馆",
    studio: "月光书房",
    synopsis: "只在深夜营业的咖啡馆，为每一位夜归人递上一杯恰好的温暖。",
    description:
      "《月下咖啡馆》讲述一间只在深夜营业的咖啡馆的故事。店主为每一位夜归人递上一杯恰好的温暖，也倾听他们的心事。作品氛围静谧温柔，适合在睡前慢慢翻阅。",
    characters: [
      { name: "店主", role: "主角", desc: "沉默寡言却善解人意的咖啡师。" },
      { name: "常客们", role: "群像", desc: "形形色色的夜归人，各自带着不同的故事。" },
    ],
  },
  {
    id: "w18",
    title: "风速传说",
    cover:
      "https://readdy.ai/api/search-image?query=Energetic%20anime%20poster%20illustration%20of%20a%20cyclist%20racing%20down%20a%20coastal%20road%20with%20motion%20lines%2C%20flat%20cel%20shading%2C%20vivid%20green%20and%20orange%20palette%2C%20clean%20dynamic%20background%2C%20sports%20poster%20style&width=600&height=800&seq=work-18&orientation=portrait",
    type: "TV动画",
    region: "日本",
    year: 2023,
    heat: 6320,
    tags: ["运动", "热血", "青春"],
    author: "原作：疾风社",
    studio: "风速制作组",
    synopsis: "一群少年以自行车为翼，向着终点全力冲刺的热血物语。",
    description:
      "《风速传说》讲述一群少年以自行车为翼，向着终点全力冲刺的热血物语。作品节奏明快，比赛场面充满张力，同时也细腻刻画了队员之间的信任与成长，是一部让人热血沸腾的运动番。",
    characters: [
      { name: "翔", role: "主角", desc: "天生热爱速度的骑手，享受风掠过耳畔的感觉。" },
      { name: "教练", role: "引路人", desc: "严厉的教练，帮助队伍找到正确的方向。" },
    ],
  },
];